/*
 *
 * GiftCardCart reducer
 *
 */

import { fromJS } from 'immutable';
import {
  DEFAULT_ACTION,
  FETCH_CARTLIST_SUCCESS,
  DELETE_CART_ITEM_SUCCESS,
  ADDTOCART_SUCCESS,
  FETCH_USER_ADDRESS,
} from './constants';

const initialValue = fromJS({ cart_obj: {}, address_user: {}, addToCart: {}, delete_status: false, isLoading: false });

function giftCardCartReducer(state = initialValue, action) {
  const { payload } = action;
  switch (action.type) {
    case DEFAULT_ACTION:
      return state
        .set('isLoading', payload);
    case FETCH_USER_ADDRESS:
      return state
        .set('address_user', fromJS(payload))
        .set('isLoading', false);
    case FETCH_CARTLIST_SUCCESS:
      return state
        .set('cart_obj', fromJS(action.payload))
        .set('isLoading', false);
    case DELETE_CART_ITEM_SUCCESS:
      return state
        .set('delete_status', payload)
        .set('isLoading', false);
    case ADDTOCART_SUCCESS:
      return state
        .set('addToCart', fromJS(payload))
        .set('isLoading', false);
    default:
      return state;
  }
}

export default giftCardCartReducer;



// WEBPACK FOOTER //
// client/containers/GiftCardCart/reducer.js